import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ConfigProvider from '../config-provider';
import Icon from '../icon';
import { KEYCODE, obj } from '../util';
import Balloon from '../balloon';

const { Tooltip } = Balloon;

class Star extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    /**
     * 自定义类名
     */
    className: PropTypes.string,
    /**
     * 自定义内敛样式
     */
    style: PropTypes.object,
    /**
     * 是否收藏(针对受控组件)
     */
    starred: PropTypes.bool,
    /**
     * 星标默认值(针对非受控组件)
     */
    defaultStarred: PropTypes.bool,
    /**
     * starred 为 false 的时候弹出文字
     */
    text: PropTypes.string,
    /**
     * starred 为 true 的时候弹出文字
     */
    starredText: PropTypes.string,
    /**
     * 与 tooltip 的 align 属性一致
     */
    align: PropTypes.string,
    /**
     * 星标状态改变时触发此事件
     * @param {Boolean} starred
     * @param {Event} e DOM事件对象
     */
    onChange: PropTypes.func,
    /**
     * 鼠标点击事件
     * @param {Event} e DOM事件对象
     */
    onClick: PropTypes.func,
    /**
     * 键盘按键事件
     * @param {Event} e DOM事件对象
     */
    onKeyDown: PropTypes.func,
  };

  static defaultProps = {
    prefix: 'next-',
    onChange: () => {},
    defaultStarred: false,
    align: 't',
  }

  constructor(props) {
    super(props);
    const starred = 'starred' in props ? props.starred : props.defaultStarred;
    this.state = {
      starred: typeof starred === 'undefined' ? '' : starred,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ('starred' in nextProps) {
      let { starred } = nextProps;
      if (starred === undefined) {
        starred = false;
      }
      this.setState({
        starred,
      });
    }
  }

  onChange = e => {
    const starred = !this.state.starred;
    if (!('starred' in this.props)) {
      this.setState({
        starred,
      });
    }
    this.props.onChange(starred, e);
    this.props.onClick && this.props.onClick(e);
  }

  onKeyDown = e => {
    if (e.keyCode === KEYCODE.ENTER || e.keyCode === KEYCODE.SPACE) {
      this.onChange(e);
    }
    this.props.onKeyDown && this.props.onKeyDown(e);
  }

  render() {
    const {
      prefix,
      className,
      style,
      text,
      starredText,
      align,
      ...others
    } = this.props;

    const { starred } = this.state;
    const type = starred ? 'star-fill' : 'starstroke';

    const iconCls = classNames({
      [`${prefix}star`]: true,
      [`${prefix}starred`]: starred,
      [className]: className,
    });

    const trigger = (
      <span
        role="star"
        tabIndex="0"
        className={`${prefix}star-wrapper`}
        onClick={this.onChange}
        onKeyDown={this.onKeyDown}
        {...obj.pickAttrs(others)}
      >
        <Icon type={type} className={iconCls} />
      </span>
    );


    if (text) {
      return (
        <Tooltip
          trigger={trigger}
          align={align}
        >
          {starred ? starredText : text}
        </Tooltip>
      );
    } else {
      return trigger;
    }
  }
}

export default ConfigProvider.config(Star);
